import { useEffect } from "react";
import { useModalMeta } from "../atoms/useModal";
import usePaymentLedgerQuery from "../queries/paymentLedger/usePaymentLedgerQuery";
import useIsOrderEditingHook from "./useIsOrderEditingHook";

const usePaymentLedgerHook = (enabled?: boolean) => {
  const [{ orderId: currentOrderId, isSession }] = useModalMeta();
  const { editOrder } = useIsOrderEditingHook();

  // it comes from session_id for session orders and from item_id for single orders
  const orderId = currentOrderId ?? editOrder?.order_information?.item_id;

  const query = usePaymentLedgerQuery(orderId, isSession);

  useEffect(() => {
    enabled && orderId && query.refetch();
  }, [enabled]);

  return { ...query, orderId, isSession };
};

export default usePaymentLedgerHook;
